import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";

const FALLBACK_COVER = "https://images.unsplash.com/photo-1522410818928-5522dacd5066?w=1200";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <SEO title="Blog — Atölye Notları" description="Wünberg blog: akrilik boya teknikleri, renk teorisi, sanatçı rehberleri ve atölye ipuçları." />
      <section className="pt-32 pb-12 border-b border-white/10">
        <div className="wb-container">
          <div className="wb-overline">Blog</div>
          <h1 className="wb-h1 mt-3">Atölye Notları</h1>
          <p className="wb-body mt-5 max-w-2xl">
            Teknik, ilham ve rehberlik — Wünberg ekibinden ve sanatçı dostlarımızdan.
          </p>
        </div>
      </section>

      <section className="wb-section">
        <div className="wb-container">
          {loading ? (
            <div className="text-[#a0aabf]">Yükleniyor...</div>
          ) : posts.length === 0 ? (
            <div className="wb-glass p-16 text-center">
              <div className="font-serif text-2xl">Henüz yazı eklenmedi</div>
              <p className="text-[#a0aabf] mt-3">Admin panelinden blog yazıları eklendikçe burada görünür.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => (
                <Link key={p.id} to={`/blog/${p.slug}`} className="wb-card group" data-testid={`blog-${p.slug}`}>
                  <div className="aspect-[16/10] overflow-hidden bg-[#0c1f44]">
                    <img src={p.cover_image || FALLBACK_COVER} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="p-6">
                    <div className="wb-overline">{(p.tags && p.tags[0]) || "Yazı"}</div>
                    <div className="font-serif text-xl mt-2 leading-snug">{p.title}</div>
                    <p className="text-sm text-[#a0aabf] mt-3 line-clamp-3">{p.excerpt}</p>
                    <div className="text-xs text-[#a0aabf] mt-4">{p.author} · {new Date(p.created_at).toLocaleDateString("tr-TR")}</div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
